import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams, ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-ag-grid-actions-wrapper',
  templateUrl: './ag-grid-actions-wrapper.component.html',
  styleUrls: ['./ag-grid-actions-wrapper.component.scss']
})
export class AgGridActionsWrapperComponent implements ICellEditorAngularComp, AfterViewInit {
  
  private params !: ICellEditorParams;
  public actionParams: any[] | undefined;


  @ViewChild('container', { read: ViewContainerRef })
  public container!: ViewContainerRef;
  public happy = false;

  // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
  ngAfterViewInit() {
    window.setTimeout(() => {
      this.container.element.nativeElement.focus();
    });
  }

  agInit(params: ICellEditorParams): void {
    if(typeof params['colDef'].cellRendererParams == "function") {
      this.actionParams = [...params['colDef'].cellRendererParams(params.data)];
    } else {
      this.actionParams = [...params['colDef'].cellRendererParams];
    }
    this.params = params;
  }

  isPopup(): boolean {
    return true;
  }

  getValue(): any {
    return this.params.data;
  }

  onSelect(actionItem: string) {
    console.log(this.params);
    this.params.context.componentParent.onGridWrapperAction(this.params.data, actionItem);
    this.params.api.stopEditing();
  }
}
